package team.platforma.aicombo.telegram

class TgSocial constructor() {
    private val botId: String = "7831772721"
    val originUrl: String = "https://icombo.dev.x840.ru/"
    val redirectUrl: String = "https://icombo.dev.x840.ru/"
    private val baseUrl = "https://oauth.telegram.org/auth?"
    val urlToRequest =
        "${baseUrl}bot_id=$botId&origin=$originUrl&embed=1&request_access=write&return_to=$redirectUrl"

    val localStorageTgKey = "tgRedirectData"
}